<div class="wrapper">
  <mat-card class="content">
    <mat-card-content>
      <h2 class="card-title">Selecteer de tijdvakken waarin jij normaal gezien beschikbaar bent</h2>
      @if (
        ((type === RoleEnum.Driver || type === RoleEnum.CoDriver) && newDaypartsDriver().length > 0) ||
        (type === RoleEnum.Planner && newDaypartsPlanner().length > 0) ||
        loading()
      ) {
        <div class="list-items">
          <div class="list-item-wrapper headers">
            <div class="list-item-col-wrapper">
              <div class="list-item-col">Dag</div>
              <div class="list-item-col hide-column">Titel</div>
              <div class="list-item-col">Tijd</div>
              <div class="list-item-col"></div>
            </div>
          </div>
          @if (type === RoleEnum.Driver || type === RoleEnum.CoDriver) {
            <cdk-virtual-scroll-viewport itemSize="50px" class="list-wrapper">
              @for (daypart of newDaypartsDriver(); track daypart.id) {
                <div class="list-item-wrapper">
                  <div class="list-item-col-wrapper">
                    <div class="list-item-col">
                      {{
                        ucFirst(
                          moment()
                            .day(daypart.day + 1)
                            .format('dddd')
                        )
                      }}
                    </div>
                    <div class="list-item-col hide-column">
                      {{ daypart.name }}
                    </div>
                    <div class="list-item-col">
                      van {{ daypart.startHour }}:{{ daypart.startMin }} tot {{ daypart.endHour }}:{{ daypart.endMin }}
                    </div>
                    <div class="list-item-col">
                      <div class="list-item-buttons">
                        <mat-slide-toggle
                          (change)="toggleChange($event, daypart.id!)"
                          [disabled]="!userCanModify"
                          [checked]="daypart.checked"
                        >
                        </mat-slide-toggle>
                      </div>
                    </div>
                  </div>
                </div>
              }
            </cdk-virtual-scroll-viewport>
          }
          @if (type === RoleEnum.Planner) {
            <cdk-virtual-scroll-viewport itemSize="50px" class="list-wrapper">
              @for (daypart of newDaypartsPlanner(); track daypart.id) {
                <div class="list-item-wrapper">
                  <div class="list-item-col-wrapper">
                    <div class="list-item-col">
                      {{
                        ucFirst(
                          moment()
                            .day(daypart.day + 1)
                            .format('dddd')
                        )
                      }}
                    </div>
                    <div class="list-item-col">
                      {{ daypart.name }}
                    </div>
                    <div class="list-item-col">
                      van {{ daypart.startHour }}:{{ daypart.startMin }} tot {{ daypart.endHour }}:{{ daypart.endMin }}
                    </div>
                    <div class="list-item-col">
                      <div class="list-item-buttons">
                        <mat-slide-toggle
                          (change)="toggleChange($event, daypart.id!)"
                          [disabled]="!userCanModify"
                          [checked]="daypart.checked"
                        >
                        </mat-slide-toggle>
                      </div>
                    </div>
                  </div>
                </div>
              }
            </cdk-virtual-scroll-viewport>
          }
        </div>
      }
      @if (
        (((type === RoleEnum.Driver || type === RoleEnum.CoDriver) && newDaypartsDriver().length === 0) ||
          (type === RoleEnum.Planner && newDaypartsPlanner().length === 0)) &&
        loading() === false
      ) {
        <p class="no-dayparts">Er zijn nog geen dagdelen aangemaakt.</p>
      }
    </mat-card-content>
  </mat-card>
</div>
